// FW 1.0.9+ K2 rows carry per-channel stim state as 0 (off) or 1 (on).
// FW 1.0.8 rows have these fields as null: the column was absent, which is
// NOT the same as stim off.
export const STIM_CHANNEL_FIELDS = {
    ch1: 'is_channel_1_stim_on_or_off',
    ch2: 'is_channel_2_stim_on_or_off',
};

// Map stim state onto the 0-100 gait-percent axis: off -> 0, on -> 100.
// Anything other than 0 or 1 (null, undefined, missing) becomes null so the
// chart leaves a gap instead of drawing it as stim off.
export const toStimPlotValue = (value) => {
    if (value === 0) return 0;
    if (value === 1) return 100;
    return null;
};

// Returns the plot values for a stim field, or null when no sample in the
// trial has the field (e.g. FW 1.0.8), so the caller can skip the series.
export const buildStimSeries = (rawData, field) => {
    const values = rawData.map(item => toStimPlotValue(item[field]));
    return values.some(value => value !== null) ? values : null;
};

export const formatStimTooltipValue = (value) => {
    if (value === 100) return 'On';
    if (value === 0) return 'Off';
    return '-';
};
